module.exports = __webpack_public_path__ + "images/17c6e1188f0ae3859d091c97f5ebaedd.svg";